import React from "react";
import { endpoints } from "config";
import * as Yup from "yup";
import { accessRightsRenderer } from "components/AccessRights/AccessRights";
import { WorkflowNotificationsFields } from "./models";
import { FieldRenderers, FormField } from "@avamae/formbuilder";
import { Data } from "./WorkflowNotifications";
import Entity from "components/Entity";
import { WorkFlowProgress } from "pages/homes/components/WorkFlowProgress";
import { stringV2Renderer } from "components/helpers/CustomFieldRenderers/CustomString/StringV2";
import {
  workflowsReadOnlyRightsRenderer,
  workflowsRightsRenderer,
} from "pages/Workflows/Workflow";

const validationSchema = Yup.object({});

type Props = {
  actionType: "create" | "edit" | "view";
  selectedData: Data[];
  onDone(): void;
  idFromRowOption: React.ReactText | null;
};

const fetchConfig = (
  selectedRows: Data[],
  idFromRowOption?: React.ReactText | null
) => {
  const {
    workflowActionInstances__Id,
    workflowActionInstances__WorkflowInstancesID,
  } = selectedRows[0];
  return {
    params: {
      Id: idFromRowOption ?? workflowActionInstances__WorkflowInstancesID,
    },
  };
};

const rightsRenderer = (): FieldRenderers<WorkflowNotificationsFields> => ({
  string: stringV2Renderer(false, null, null),
  unknown: <T,>(_key: React.ReactText, field: FormField<T>) => (
    <WorkFlowProgress
      label={field.label as string}
      fieldName={field.name as string}
    />
  ),
});

const readOnlyRightsRenderer = (): FieldRenderers<WorkflowNotificationsFields> => ({
  string: stringV2Renderer(true, null, null),
  unknown: <T,>(_key: React.ReactText, field: FormField<T>) => (
    <WorkFlowProgress
      label={field.label as string}
      fieldName={field.name as string}
    />
  ),
});

function WorkflowNotification(props: Props): JSX.Element {
  const { actionType, selectedData, idFromRowOption } = props;

  const initialDataUrl = selectedData[0].bCommunication ? endpoints.home.viewCommunication : endpoints.home.viewWorkflow;
  const hiddenFields = selectedData[0].bCommunication ? ["bExistingUser", "workflowName"] : ["bExistingUser", "workflowName", "communication"];
  const hiddenGroups = selectedData[0].bCommunication ? ["Workflow Name", "Document"] : ["Workflow Name", "Trigger Communication"];
  return (
    <Entity
      initialDataUrl={initialDataUrl}
      readOnly={actionType === "view"}
      submitUrl={initialDataUrl}
      onDone={props.onDone}
      selectedData={selectedData}
      idFromRowOption={idFromRowOption}
      formType="json"
      fieldRenderers={workflowsRightsRenderer}
      hiddenFields={hiddenFields}
      hiddenGroups={hiddenGroups}
      hideGroupLabels={["Details", "Document"]}
      fieldsInBoxes={true}
      groupColumns={{ workflowprogress: 2 }}
      validationSchema={validationSchema}
      readOnlyFieldRenderers={workflowsReadOnlyRightsRenderer}
      nullStringValues={[]}
      fetchConfig={actionType === "create" ? undefined : fetchConfig}
      hideViewGroupLabel={true}
      noSubmit
    />
  );
}

export default WorkflowNotification;
